export default class LanguageButton {
    constructor() {
        const languageButtons = document.querySelectorAll('.js-language-button')
        languageButtons.forEach(
            btn => this.initLanguageButton(btn)
        )
    }

    initLanguageButton(btn) {
        const targetLink = btn.dataset.link;
        btn.addEventListener('click', (event) => {
            btn.classList.add('language-button__toggle')
            setTimeout(() => {
                window.location.href = targetLink;
            }, 300);
        })
    }
}
